/**
 * Las tipografías entran por el bundle, no por un CDN.
 *
 * La aplicación las pedía a `fonts.googleapis.com` en tiempo de ejecución, así
 * que si el CDN no respondía —o la red del cliente lo bloqueaba— la pantalla
 * caía al stack del sistema y las cifras dejaban de alinearse igual en dos
 * equipos. Con Fontsource los archivos son parte de la compilación y la versión
 * queda fijada en `package.json`.
 *
 * Dos oficios, y la línea entre ellos es la que separa la APLICACIÓN del
 * DOCUMENTO que contiene:
 *
 * * el armazón —menú, barra superior, botones, migas— va en Inter, empaquetada.
 *   Es la identidad del producto y no puede cambiar de un equipo a otro.
 * * el contenido contable —tablas, estados, cifras— va en la pila del SISTEMA,
 *   que es la de Odoo. Ahí la familiaridad vale más que la identidad: el
 *   contador compara esa pantalla con la de Odoo todos los días y la métrica
 *   tiene que coincidir. Esa es la única que no se empaqueta, a propósito.
 *
 * Y el documento va en Lato, que es la del PDF: si dependiera del sistema, la
 * vista previa de «Formato oficial» dejaría de parecerse a lo que se firma.
 */
import "@fontsource-variable/inter/wght.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
// Lato es la tipografía del DOCUMENTO —la del PDF y la del Excel del contador—.
// La usan solo las superficies que son vista previa de un entregable.
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
